var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent, forwardRef } from 'react';
import hoistStatics from 'hoist-non-react-statics';
import { SmartKeyConsumer } from './SmartKeyContext';
import SmartKeyBinder from './SmartKeyBinder';
export default function withSmartKey(WithSmartKeyComponent) {
    class SmartKeyComponent extends PureComponent {
        constructor(props) {
            super(props);
            this.smartKeyBinder = new SmartKeyBinder(props, WithSmartKeyComponent.smartKeyName);
        }
        render() {
            const _a = this.props, { forwardedRef, smartKey, smartKeyParams } = _a, props = __rest(_a, ["forwardedRef", "smartKey", "smartKeyParams"]);
            return (<SmartKeyConsumer>
          {({ i18n, a11y, isDev }) => {
                return (<WithSmartKeyComponent ref={forwardedRef} {...props} {...this.smartKeyBinder.getBindableProps(i18n, a11y, props, isDev || false, {
                    smartKey,
                    smartKeyParams,
                })}/>);
            }}
        </SmartKeyConsumer>);
        }
    }
    const WithSmartKeyFactory = (props, ref) => (<SmartKeyComponent {...props} forwardedRef={ref}/>);
    return hoistStatics(forwardRef(WithSmartKeyFactory), WithSmartKeyComponent);
}
;
